import SVG from 'react-inlinesvg';

export const CoreIcon = ({ style = {}, ...props }) => (
  <SVG
    style={{
      ...style,
      minWidth: props.width,
    }}
    {...props}
  />
);
